import React, { useState, useEffect } from "react";
import styles from "./HeaderDropDownMobile.module.scss";
import { Link, NavLink } from "react-router-dom";
import { useAppSelector } from "../../../hooks/hook";
import { RootState } from "../../../redux/store";
import { ReactComponent as ArrowIcon } from "../../../assets/images/header/icons/arrow.svg";
import { ReactComponent as BackIcon } from "../../../assets/images/header/icons/back.svg";
interface HeaderDropdownProps {
  activeCategory: any[];
  onClick: () => void;
  path: string;
  isMobileDropdownOpen: boolean;
  setMobileNavbar: (value: boolean) => void;
  translations?: any;
}

const HeaderDropDownMobile: React.FC<HeaderDropdownProps> = ({
  activeCategory,
  onClick,
  path,
  isMobileDropdownOpen,
  setMobileNavbar,
  translations,
}) => {
  const [currentStep, setCurrentStep] = useState<number>(1);
  const [selectedCategory, setSelectedCategory] = useState<any>(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState<any>(null);
  const theme = useAppSelector((state: RootState) => state.theme.mode);

  useEffect(() => {
    setCurrentStep(1);
    setSelectedCategory(null);
    setSelectedSubCategory(null);
  }, [path]);

  useEffect(() => {
    if (
      isMobileDropdownOpen &&
      activeCategory.length > 0 &&
      path !== "others"
    ) {
      setSelectedCategory(activeCategory[0]);
    }
  }, [isMobileDropdownOpen, activeCategory, path]);

  const handleBackClick = () => {
    if (currentStep === 3) {
      setCurrentStep(2);
    } else if (currentStep === 2) {
      setCurrentStep(1);
    }
  };

  const renderProducts = () => (
    <>
      {currentStep === 1 && (
        <ul className={styles.category_items}>
          {activeCategory.map((category) => (
            <li
              key={category.id}
              className={
                theme === "dark"
                  ? styles.dropdown_category_dark
                  : styles.dropdown_category
              }
              onClick={() => {
                setSelectedCategory(category);
                setCurrentStep(2);
              }}
            >
              <Link
                to={`products/${category.id}`}
                className={styles.category_name}
              >
                {category.name}
              </Link>
              <ArrowIcon
                className={
                  theme === "dark" ? styles.iconDark : styles.iconLight
                }
              />
            </li>
          ))}
        </ul>
      )}

      {currentStep === 2 && selectedCategory && (
        <ul className={styles.category_items}>
          <li className={styles.backButton} onClick={handleBackClick}>
            <BackIcon
              className={theme === "dark" ? styles.iconDark : styles.iconLight}
            />
            <p>{selectedCategory.name}</p>
          </li>
          {selectedCategory.children?.map((subCategory: any) => (
            <li
              key={subCategory.id}
              className={styles.dropdown_category}
              onClick={() => {
                setSelectedSubCategory(subCategory);
                setCurrentStep(3);
              }}
            >
              <Link
                to={`products/${subCategory.id}`}
                className={styles.category_name}
              >
                {subCategory.name}
              </Link>
              <ArrowIcon
                className={
                  theme === "dark" ? styles.iconDark : styles.iconLight
                }
              />
            </li>
          ))}
        </ul>
      )}

      {currentStep === 3 && selectedSubCategory && (
        <ul className={styles.category_items}>
          <li className={styles.backButton} onClick={handleBackClick}>
            <BackIcon
              className={theme === "dark" ? styles.iconDark : styles.iconLight}
            />{" "}
            <p>{selectedSubCategory.name}</p>
          </li>
          {selectedSubCategory.children?.map((item: any) => (
            <li key={item.id}>
              <NavLink
                to={`/products/${item.id}`}
                className={styles.dropdown_category}
                onClick={() => setMobileNavbar(false)}
              >
                <span style={{ color: "#000" }}>{item.name}</span>
                <ArrowIcon
                  className={
                    theme === "dark" ? styles.iconDark : styles.iconLight
                  }
                />
              </NavLink>
            </li>
          ))}
        </ul>
      )}
    </>
  );
  const renderServices = () => (
    <>
      {currentStep === 1 && (
        <ul className={styles.category_items}>
          {activeCategory.map((serviceGroup) => (
            <li
              key={serviceGroup.id}
              className={
                theme === "dark"
                  ? styles.dropdown_category_dark
                  : styles.dropdown_category
              }
              onClick={() => {
                setSelectedCategory(serviceGroup);
                setCurrentStep(2);
              }}
            >
              <div className={styles.category_name}>{serviceGroup.name}</div>
              <ArrowIcon
                className={
                  theme === "dark" ? styles.iconDark : styles.iconLight
                }
              />
            </li>
          ))}
        </ul>
      )}

      {currentStep === 2 && selectedCategory && (
        <ul className={styles.category_items}>
          <li className={styles.backButton} onClick={handleBackClick}>
            <BackIcon
              className={theme === "dark" ? styles.iconDark : styles.iconLight}
            />{" "}
            <p>{translations?.services}</p>
          </li>
          {selectedCategory.services?.map((service: any) => (
            <li key={service.id}>
              <NavLink
                to={selectedCategory.name === "Təmir" ? "/repair" : "/install"}
                className={styles.dropdown_category}
                onClick={() => setMobileNavbar(false)}
              >
                {service.name}
                <ArrowIcon
                  className={
                    theme === "dark" ? styles.iconDark : styles.iconLight
                  }
                />
              </NavLink>
            </li>
          ))}
        </ul>
      )}
    </>
  );

  const renderOtherPages = () => (
    <ul className={styles.category_items}>
      <li>
        <NavLink
          to="/campaigns"
          className={styles.dropdown_category}
          onClick={() => setMobileNavbar(false)}
        >
          {translations?.campaigns}
          <ArrowIcon
            className={theme === "dark" ? styles.iconDark : styles.iconLight}
          />
        </NavLink>
      </li>
      <li>
        <NavLink
          to="/about"
          className={styles.dropdown_category}
          onClick={() => setMobileNavbar(false)}
        >
          {translations?.about_us}
          <ArrowIcon
            className={theme === "dark" ? styles.iconDark : styles.iconLight}
          />
        </NavLink>
      </li>
      <li>
        <NavLink
          to="/contact"
          className={styles.dropdown_category}
          onClick={() => setMobileNavbar(false)}
        >
          {translations?.contact}
          <ArrowIcon
            className={theme === "dark" ? styles.iconDark : styles.iconLight}
          />
        </NavLink>
      </li>
    </ul>
  );

  return (
    <div className={styles.mobile_dropdown} onClick={onClick}>
      <div className={styles.dropdown_content}>
        {path === "products" && renderProducts()}
        {path === "services" && renderServices()}
        {path === "others" && renderOtherPages()}
      </div>
    </div>
  );
};

export default HeaderDropDownMobile;
